import i18n from '@/i18n'
export const formatterArray = () =>
  new Intl.ListFormat(i18n.locale, {
    tyle: 'long',
    type: 'conjunction',
  })
